import { create } from "zustand";
import { persist } from "zustand/middleware";

interface ProjectState {
  /** Currently selected project ID (from URL or last-selected). */
  selectedProjectId: string | null;
  /** Cached project name for display while data loads. */
  selectedProjectName: string | null;
  /** Set both ID and name when user selects a project. */
  selectProject: (id: string, name: string) => void;
  /** Clear selection (e.g. when navigating to project list). */
  clearProject: () => void;
}

export const useProjectStore = create<ProjectState>()(
  persist(
    (set) => ({
      selectedProjectId: null,
      selectedProjectName: null,
      selectProject: (id, name) =>
        set({ selectedProjectId: id, selectedProjectName: name }),
      clearProject: () =>
        set({ selectedProjectId: null, selectedProjectName: null }),
    }),
    {
      name: "ftl-project",
    },
  ),
);
